import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useRef } from "react";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import QRCode from "react-qr-code";
import { ChangeCursor } from "./MiscFunctions";
import { Col, Container, Row } from "react-bootstrap";
import jsQR from "jsqr";
import QRCodeScanner from "./QRCodeScanner";
import { Card, TableBody, TableHead, Box, Grid, Typography, Button, Icon, Divider } from "@mui/material";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import showPromptDialog from "../../../components/ShowConfirmDialog/ShowPromptDialog";
import "./ScanPatientQR.scss";
import { DataGrid, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector } from "@mui/x-data-grid";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import { SaveAlt } from "@mui/icons-material";
import { formatDateIST } from "../../doctor-console/Utils/UtilsFunctions";
import { usePermissions } from "../../login/PermissionContext";

function ScanPatientQR() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue: setFormValue,
  } = useForm();
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  // const [value, setValue] = useState({ hipId: "HLTHTEK_DEV", code: 1234 });
  const [value, setValue] = useState("");
  const [title, setTitle] = useState("");
  const [back, setBack] = useState("#FFFFFF");
  const [fore, setFore] = useState("#000000");
  const [size, setSize] = useState("25%");
  const [selectedFile, setSelectedFile] = useState(null);
  const [decodedData, setDecodedData] = useState(null);
  const [accessToken, setAccessToken] = useState("");

  const [healthIdDetails, setHealthIdDetails] = useState("");
  const [patientList, setPatientList] = useState("");
  const [selectedPatient, setSelectedPatient] = useState("");
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [showFinalData, setShowFinalData] = useState(false);
  const [purpose, setPurpose] = useState("");
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("All");
  const [displayExistingDetails, setDisplayExistingDetails] = useState(false);
  const [scanShareRecords, setScanShareRecords] = useState(false);
  const qrCardRef = useRef(null);
  const [qrCardHeight, setQrCardHeight] = useState(null);
  const [registrationType, setRegistrationType] = useState("abdm");
  const [orgCode, setOrgCode] = useState(
    sessionStorage.getItem("ORG_CODE") || ""
  );
  const [appMode, setAppMode] = useState(
    sessionStorage.getItem("APP_MODE") || ""
  );
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );
  const nonAbdmQrRef = useRef(null);
  const { userInfo } = usePermissions();
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

  const REACT_APP_HIP_ID_URL_SB = process.env.REACT_APP_HIP_ID_URL_SB;
  const REACT_APP_HIP_ID_URL_PR = process.env.REACT_APP_HIP_ID_URL_PR;
  const REACT_APP_IS_ABDM_CONNECTED_WITH_PROD =
    process.env.REACT_APP_IS_ABDM_CONNECTED_WITH_PROD;
  const REACT_APP_HIP_ID_URL =
    REACT_APP_IS_ABDM_CONNECTED_WITH_PROD === "true"
      ? REACT_APP_HIP_ID_URL_PR
      : REACT_APP_HIP_ID_URL_SB;

  const nonAbdmBaseUrl = useMemo(() => {
   
    const appendRegisterPath = (base) =>
      `${base.replace(/\/+$/, "")}/register_patient_qr`;
    try {
      const parsedUrl = new URL(REACT_APP_BACKEND_ROUTE_URL);
      return appendRegisterPath(parsedUrl.origin);
    } catch (err) {
      return appendRegisterPath(REACT_APP_BACKEND_ROUTE_URL);
    }
  }, [REACT_APP_BACKEND_ROUTE_URL]);

  const nonAbdmQrUrl = useMemo(() => {
    const baseUrl = nonAbdmBaseUrl || "";
    const resolvedOrgCode = orgCode || "";
    const resolvedAppMode = appMode || "";
    const contextFacilityName = (userInfo?.facility_name || "").trim();
    const resolvedFacility = contextFacilityName || facilityName || "";
    const params = new URLSearchParams({
      org_code: resolvedOrgCode,
      app_mode: resolvedAppMode,
      facility: resolvedFacility,
    });
    return `${baseUrl}?${params.toString()}`;
  }, [nonAbdmBaseUrl, orgCode, appMode, facilityName, userInfo?.facility_name]);

  const rawAbdmFlag =
    userInfo?.abdm_enabled !== undefined
      ? userInfo?.abdm_enabled
      : userInfo?.abdm;
  const isAbdmEnabled =
    rawAbdmFlag === true ||
    rawAbdmFlag === "true" ||
    rawAbdmFlag === 1 ||
    rawAbdmFlag === "1";

  useEffect(() => {
    if (!isAbdmEnabled && registrationType !== "non-abdm") {
      setRegistrationType("non-abdm");
    }
  }, [isAbdmEnabled, registrationType]);

  const [userRole, setUserRole] = useState(sessionStorage.getItem("roleType"));

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  useEffect(() => {
    setOrgCode(sessionStorage.getItem("ORG_CODE") || "");
    setAppMode(sessionStorage.getItem("APP_MODE") || "");
    setFacilityName(
      (prev) => prev || sessionStorage.getItem("facility_name") || ""
    );
  }, []);

  useEffect(() => {
    if (userInfo?.facility_name) {
      setFacilityName(userInfo.facility_name);
    }
  }, [userInfo?.facility_name]);

  useEffect(() => {
    if (!isAbdmEnabled) {
      return;
    }
    if (
      sessionStorage.getItem("roleType") !== "admin" &&
      authToken !== undefined &&
      authToken.length > 0
    ) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
          headers: headers,
        })
        // .then((res) => {
        //   setTitle(res.data.facility_id);
        //   setValue(
        //     `https://phrsbx.abdm.gov.in/share-profile?hip-id=${res.data.facility_id}&counter-id=1234`
        //   );
        //   sessionStorage.setItem(
        //     "subscription_type",
        //     res.data.subscription_type
        //   );
        // });
        .then((res) => {
          // setTitle(res.data.facility_id);
          // setValue(
          //   `${REACT_APP_HIP_ID_URL}${res.data.facility_id}&counter-id=${process.env.REACT_APP_COUNTER_ID}`
          // );
          // sessionStorage.setItem(
          //   "subscription_type",
          //   res.data.subscription_type
          // );
          if (res?.data?.name) {
            sessionStorage.setItem("facility_name", res.data.name);
            setFacilityName(res.data.name);
          }
          axios
            .post(
              `${REACT_APP_BACKEND_ROUTE_URL}get_facility_by_qr_code/`,
              {
                // facility_id: "harmony-diagnostics",
                facility_id: res.data.facility_id,
                department_name: selectedDepartment,
              },
              {
                headers: headers,
              }
            )
            .then((res2) => {
              // console.log("qr response-->", res2);
              if (res2.data.status === "Success") {
                setValue(res2.data.data);
              } else {
                toast.error(res2.data.message);
                setValue("");
              }
            })
            .catch((err) => {
              toast.error(err);
            });
        });
    }
  }, [authToken, selectedDepartment, isAbdmEnabled]);

  useEffect(() => {
    if (isAbdmEnabled) {
      fetchPatientList();
    }
  }, [authToken, isAbdmEnabled]);

  const history = useHistory();
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const fetchPatientList = () => {
    if (!isAbdmEnabled) {
      return;
    }
    if (Token()) {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  };

  const getAllFacilityDepartments = () => {
    if (!isAbdmEnabled) {
      return;
    }
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`, {
        headers,
      })
      .then((res) => {
        if (res.data.status == "Success") {
          const departmentsData = res.data.department_list.map(
            (dept, index) => ({
              id: index + 1,
              department_name: dept.department,
              department_id: dept.department_id,
            })
          );
          console.log("departmentData-->", departmentsData);
          setDepartments([
            { id: 0, department_name: "All", department_id: "All" },
            ...departmentsData,
          ]);
        } else {
          console.log("error in getting the department ");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  console.log("departments-->", departments);
  useEffect(() => {
    if (isAbdmEnabled) {
      getAllFacilityDepartments();
    }
  }, [isAbdmEnabled]);
  useEffect(() => {
    if (!isAbdmEnabled) {
      return;
    }
    if (selectedPatient !== null && decodedData) {
      // proceedWithOtherEndpoints(decodedData);
      AddCareContext(decodedData);
    }
  }, [selectedPatient, isAbdmEnabled]);

  // Measure QR card height to match Scan & Share card height
  useEffect(() => {
    if (qrCardRef.current) {
      setQrCardHeight(qrCardRef.current.offsetHeight);
    }
    const onResize = () => {
      if (qrCardRef.current) {
        setQrCardHeight(qrCardRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [
    value,
    departments,
    selectedDepartment,
    showFinalData,
    healthIdDetails,
    purpose,
    displayExistingDetails,
    scanShareRecords,
    registrationType,
  ]);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // console.log(selectedFile);

  // const handleUpload = () => {
  //   if (selectedFile) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(selectedFile);

  //     reader.onloadend = () => {
  //       const base64Data = reader.result.split(",")[1];
  //       while (base64Data.length % 4 !== 0) {
  //         base64Data += "=";
  //       }
  //       // console.log(base64Data);

  //       // const formData = new FormData();
  //       // formData.append("image", selectedFile);
  //       // console.log(formData);

  //       axios
  //         .post(
  //           // "http://127.0.0.1:8000/app/api/decode_base64_qr/",
  //           REACT_APP_BACKEND_ROUTE_URL + "decode_base64_qr/",
  //           { base64Data },
  //           {
  //             headers: headers,
  //           }
  //         )
  //         .then((res) => {
  //           if (res.data.msg === "Success") {
  //             const data = JSON.parse(res.data.decoded_data);
  //             console.log(data);
  //             setDecodedData(data);

  //             var post_data = {};
  //             post_data.query = {};

  //             post_data.query.id = data.phr;
  //             post_data.query.purpose = "KYC_AND_LINK";
  //             post_data.query.requester = {
  //               type: "HIP",
  //               id: "HLTHTEK_DEV",
  //             };
  //             post_data.query.authMode = "DEMOGRAPHICS";

  //             console.log(post_data);

  //             axios
  //               .post(
  //                 `${REACT_APP_BACKEND_ROUTE_URL}auth_init_workflow/`,
  //                 JSON.stringify(post_data),
  //                 {
  //                   headers: headers,
  //                 }
  //               )
  //               .then((res1) => {
  //                 console.log("Auth init workflow response", res1);
  //                 if (res1.data.status !== "") {
  //                   var date = data.dob;
  //                   var dateParts = date.split("-");
  //                   const newDate =
  //                     dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];

  //                   var post_data1 = {};
  //                   post_data1.credential = {};

  //                   post_data1.transactionId = res1.data.transaction_id;
  //                   post_data1.credential.demographic = {};
  //                   post_data1.credential.demographic.name = data.name;
  //                   post_data1.credential.demographic.gender = data.gender;
  //                   post_data1.credential.demographic.dateOfBirth = newDate;
  //                   post_data1.credential.demographic.authCode = "";
  //                   console.log(post_data1);
  //                   axios
  //                     .post(
  //                       `${REACT_APP_BACKEND_ROUTE_URL}auth_confirm_workflow/`,
  //                       JSON.stringify(post_data1),
  //                       {
  //                         headers: headers,
  //                       }
  //                     )
  //                     .then((res2) => {
  //                       console.log("Auth confirm workflow response", res2);
  //                       if (res.data.status !== "") {
  //                         //ChangeCursor();
  //                       }
  //                     })
  //                     .catch((err) => {
  //                       console.log(err);
  //                       toast.error(err);
  //                       //ChangeCursor();
  //                     });
  //                 }
  //               })
  //               .catch((err) => {
  //                 console.log(err);
  //                 toast.error(err);
  //                 //ChangeCursor();
  //               });
  //           } else {
  //             console.log(res.data.msg);
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //           toast.error(err);
  //           //ChangeCursor();
  //         });
  //     };
  //   }
  // };

  const handleUpload = () => {
    if (!isAbdmEnabled) {
      return;
    }
    if (selectedFile) {
      const reader = new FileReader();
      reader.readAsDataURL(selectedFile);

      reader.onloadend = () => {
        const imageSrc = reader.result;

        const img = new Image();
        img.onload = function () {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);

          const imageData = ctx.getImageData(0, 0, img.width, img.height);
          const code = jsQR(imageData.data, imageData.width, imageData.height);

          if (code) {
            // toast.success(code.data);
            const decodedData = JSON.parse(code.data);
            setDecodedData(decodedData);
            console.log(decodedData, "decodedData");
            console.log("patient list", patientList);
            if (patientList && patientList.length > 0) {
              const matchedPatient = patientList.find(
                (patient) => patient.abha_id === decodedData.hid
              );

              console.log("matchedPatient", matchedPatient);
              if (!matchedPatient) {
                const newData = {
                  abhaAddress: decodedData.hid,
                  abhaNumber: decodedData.hidn,
                  firstname: decodedData.name.split(" ")[0] || "",
                  middlename:
                    decodedData.name.split(" ").slice(1, -1).join(" ") || "",
                  lastname:
                    decodedData.name.split(" ").slice(-1).join(" ") || "",
                  gender: decodedData.gender,
                  dateOfBirth:
                    decodedData.dob.split("-").reverse().join("-") || "",
                  country: "INDIA", // Assuming country is always India
                  state: decodedData["state_name"].toUpperCase() || "",
                  district: decodedData["district_name"].toUpperCase() || "",
                  locality: decodedData.address || "",
                  pincode: "", // You may need to add pincode data if available
                  phoneNumber: decodedData.mobile || "",
                  emailId: "", // You may need to add email data if available
                  height: "", // You may need to add height data if available
                  weight: "", // You may need to add weight data if available
                  uploaded_photo: {}, // You may need to add photo data if available
                  patientName: `${decodedData.name}` || "",
                  yearOfBirth: decodedData.dob.split("-")[2] || "",
                  monthOfBirth: decodedData.dob.split("-")[1] || "",
                  dayOfBirth: decodedData.dob.split("-")[0] || "",
                  healthIdNumber: decodedData.hidn || "",
                  healthId: decodedData.hid || "",
                };

                console.log("finalttt", newData);

                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}add_patient/`,
                    JSON.stringify(newData),
                    {
                      headers: headers,
                    }
                  )
                  .then((response) => {
                    if (
                      response.data.message ===
                      "Patient created successfully !!"
                    ) {
                      toast.success(response.data.message);
                      // fetchPatientList();
                      setSelectedPatient(response.data.patient);
                      fetchPatientList();

                      // Proceed with other endpoints after patient registration
                      // proceedWithOtherEndpoints(decodedData);
                    } else {
                      const message =
                        response.data.message || "An unknown error occurred.";

                      if (message.includes("corrupted")) {
                        toast.error(
                          "The Facility documents uploaded are corrupted. Please try with a different document."
                        );
                      } else if (message.includes("virus")) {
                        toast.error(
                          "The Facility documents uploaded has virus. Please try with a different document."
                        );
                      } else {
                        toast.error(
                          `${response.data.message} Patient Name: ${response.data.patient.name}  Patient ID: ${response.data.patient.patient_id}`
                        );
                      }
                    }
                    console.log(response);
                  })
                  .catch((error) => {
                    console.error("Error:", error);
                  });
              } else {
                // Patient found, proceed with other
                console.log("patient not found in the facility");
                // proceedWithOtherEndpoints(decodedData);
                AddCareContext(decodedData);
              }
            } else {
              console.log("No patients found in the list");
            }
          } else {
            toast.error("No QR code found.");
          }
        };
        img.src = imageSrc;
      };
    }
  };

  const proceedWithOtherEndpoints = (decodedData) => {
    if (!isAbdmEnabled) {
      return;
    }
    console.log("flag");
    console.log("decodedData", decodedData);
    const postData = {
      query: {
        id: decodedData.hid,
        purpose: "KYC_AND_LINK",
        requester: {
          type: "HIP",
          id: sessionStorage.getItem("facility_name"),
        },
        authMode: "DEMOGRAPHICS",
      },
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}auth_init_workflow/`,
        JSON.stringify(postData),
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log("auth_init_workflow response:", response.data);

        // Call auth_confirm_workflow endpoint if auth_init_workflow was successful
        if (response.data.status !== "") {
          var postData2 = {};
          postData2.credential = {};

          postData2.transactionId = response.data.transaction_id;
          postData2.credential.demographic = {};
          postData2.credential.demographic.name = decodedData.name;
          postData2.credential.demographic.gender = decodedData.gender;
          postData2.credential.demographic.dateOfBirth = decodedData.dob;
          postData2.credential.demographic.authCode = "";
          axios
            .post(
              `${REACT_APP_BACKEND_ROUTE_URL}auth_confirm_workflow/`,
              JSON.stringify(postData2),
              {
                headers: headers,
              }
            )
            .then(async (response2) => {
              console.log("auth_confirm_workflow response:", response2.data);
              console.log("tdata", selectedPatient);
              if (response2.data.status == "Success") {
                var post_data2 = {};
                post_data2.link = {};
                post_data2.link.accessToken = response2.data.access_token;
                post_data2.link.patient = {};
                if (!selectedPatient) {
                  // If selectedPatient is empty, find a matched patient from patientList based on decodedData.hid
                  const matchedPatient = patientList.find(
                    (patient) => patient.abha_id === decodedData.hid
                  );
                  if (matchedPatient) {
                    post_data2.link.patient.referenceNumber =
                      matchedPatient.patient_id;
                    post_data2.link.patient.display = matchedPatient.abha_id;
                  } else {
                    console.log("No matching patient found");
                  }
                } else {
                  // If selectedPatient is not empty, use its data
                  post_data2.link.patient.referenceNumber =
                    selectedPatient.patient_id;
                  post_data2.link.patient.display = selectedPatient.abha_id;
                }
                post_data2.link.patient.careContexts = [];
                var careContextData = {};
                const displayValue = await showPromptDialog(
                  "Enter visit purpose"
                );
                setPurpose(displayValue);
                careContextData.display = displayValue || "";
                post_data2.link.patient.careContexts[0] = careContextData;

                axios
                  .post(
                    `${REACT_APP_BACKEND_ROUTE_URL}add_context_workflow/`,
                    JSON.stringify(post_data2),
                    {
                      headers: headers,
                    }
                  )
                  .then((res) => {
                    console.log("Add Visit Purpose", res.data);
                    if (res.data.status !== "") {
                      toast.success(`Status: ${res.data.status}`);
                      setShowFinalData(true);
                      setHealthIdDetails(res.data);
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    toast.error(err);
                  });
              }
            })
            .catch((error2) => {
              console.error("Error in auth_confirm_workflow:", error2);
              toast.error("Error in auth_confirm_workflow:", error2);
            });
        }
      })
      .catch((error) => {
        console.error("Error in auth_init_workflow:", error);
      });
  };

  const AddCareContext = async (decodedData) => {
    if (!isAbdmEnabled) {
      return;
    }
    // Prompt the user to enter visit purpose
    const displayValue = await showPromptDialog("Enter visit purpose");

    if (!displayValue) {
      return;
    }

    // Assuming setPurpose is a function to set the visit purpose somewhere in the state or context
    setPurpose(displayValue);

    // Initialize reqBody variable
    let reqBody = {};

    // Check if a patient is selected or needs to be matched from the patient list
    if (!selectedPatient) {
      const matchedPatient = patientList.find(
        (patient) => patient.abha_id === decodedData.hid
      );
      if (matchedPatient) {
        reqBody = {
          patient_id: matchedPatient.patient_id,
          visit_details: displayValue || "",
        };
      } else {
        console.log("No matching patient found");
        return; // Exit the function early if no patient is found
      }
    } else {
      reqBody = {
        patient_id: selectedPatient.patient_id,
        visit_details: displayValue || "",
      };
    }

    // Perform the POST request to create the care context
    try {
      const res = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}create_care_context/`,
        JSON.stringify(reqBody),
        {
          headers: headers,
        }
      );
      toast.success(
        `Visit Purpose Reference Id "${res.data.ref_num}"This ID will be used for linking to ABDM.`
      );
      console.log("Add Visit Purpose", res.data);
    } catch (err) {
      console.log(err);
      toast.error(err);
    }
  };

  const navigate = (e) => {
    history.push(`/${e.target.id}`);
  };

  console.log(value);
  console.log(title);

  const handleDownloadAndPrint = async () => {
    if (!value) {
      toast.error("QR not available");
      return;
    }
    try {
      const isDataUrl = typeof value === "string" && value.startsWith("data:");
      if (isDataUrl) {
        const link = document.createElement("a");
        link.href = value;
        link.download = "patient-qr.png";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        const res = await fetch(value, { credentials: "omit" });
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "patient-qr.png";
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.log(err);
    } finally {
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(
          `<html><head><title>Print QR</title><style>body{margin:0;display:flex;align-items:center;justify-content:center;height:100vh;background:#fff}img{width:300px;height:300px}</style></head><body><img src="${value}" alt="QR" onload="window.focus();window.print();setTimeout(()=>window.close(),300);" /></body></html>`
        );
        printWindow.document.close();
      } else {
        toast.info("Please allow pop-ups to print the QR.");
      }
    }
  };

  const handleDownloadNonAbdmQr = () => {
    if (!nonAbdmQrUrl) {
      toast.error("Registration URL not available");
      return;
    }
    if (!nonAbdmQrRef.current) {
      toast.error("QR not ready yet");
      return;
    }

    const svgElement = nonAbdmQrRef.current.querySelector("svg");
    if (!svgElement) {
      toast.error("Unable to locate QR image");
      return;
    }

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svgElement);
    const canvas = document.createElement("canvas");
    const img = new Image();
    const svgBlob = new Blob([svgString], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      const padding = 24;
      const targetWidth = img.width || 256;
      const targetHeight = img.height || 256;
      canvas.width = targetWidth + padding * 2;
      canvas.height = targetHeight + padding * 2;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, padding, padding, targetWidth, targetHeight);
      URL.revokeObjectURL(url);
      const pngUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = "non-abdm-registration-qr.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    img.onerror = () => {
      toast.error("Unable to prepare downloadable QR");
      URL.revokeObjectURL(url);
    };

    img.src = url;
  };

  // Scan & Share Records handlers and helpers (merged from scan-share records/index.js)
  const getScanShareRecords = (data, e) => {
    e.preventDefault();
    if (Token()) {
      var post_data = {};
      post_data.start_date = data.start_datetime;
      post_data.end_date = data.end_datetime;

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_scan_share_token_details/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            setScanShareRecords(res.data);
            setDisplayExistingDetails(true);
          } else {
            toast.success(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };

  const getRowClassName = (params) => {
    return "custom-row";
  };

  const scanShareColumns = [
    { field: "id", headerName: "Sl. No." },
    { field: "patient_id", headerName: "Patient ID", width: 100 },
    { field: "name", headerName: "Patient name", width: 160 },
    { field: "phone", headerName: "Phone", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    { field: "age", headerName: "Age", width: 50 },
    { field: "dob", headerName: "DOB", width: 100 },
    { field: "token", headerName: "Token", width: 80 },
    { field: "abha_no", headerName: "ABHA Number", width: 150 },
    { field: "abha_id", headerName: "ABHA Address", width: 160 },
    { field: "facility_name", headerName: "Facility Name", width: 200 },
    { field: "date_of_creation", headerName: "Date of Creation", width: 250 },
    { field: "status", headerName: "Status", width: 100 },
  ];

  const scanShareRows = scanShareRecords
    ? scanShareRecords.scan_share_token_list.map((item, index) => {
        return {
          id: index + 1,
          patient_id: item.patient_id ?? "-",
          status: item.status ?? "-",
          token: item.token ?? "-",
          name: item.name ?? "-",
          gender: item.gender ?? "-",
          age: item.age ?? "-",
          phone: item.phone ?? "-",
          abha_no:
            item.abha_no !== null && item.abha_no.length > 0
              ? item.abha_no
              : "Not Available",
          abha_id:
            item.abha_id !== null && item.abha_id.length > 0
              ? item.abha_id
              : "Not Available",
          facility_name: item.facility_name ?? "-",
          dob: item.dob ?? "-",
          date_of_creation: item.date_of_creation
            ? formatDateIST(item.date_of_creation)
            : "-",
        };
      })
    : [];

  const generatePdf = () => {
    const doc = new jsPDF();
    let tableHeaders, tableData;
    tableHeaders = scanShareColumns.map((column) => column.headerName);
    tableData = scanShareRows.map((row) => scanShareColumns.map((column) => row[column.field]));
    doc.setFontSize(12);
    doc.text("Scan & Share Records", 10, 10);
    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 20,
      styles: { fontSize: 10, textColor: [0, 0, 0] },
    });
    doc.save("scan_share_records.pdf");
  };

  const generateCsvData = () => {
    const headers = scanShareColumns.map((column) => column.headerName);
    const csvData = [
      headers,
      ...scanShareRows.map((row) => scanShareColumns.map((column) => row[column.field])),
    ];
    return csvData;
  };

  useEffect(() => {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };
    setFormValue("start_datetime", formatDate(firstDayOfMonth));
    setFormValue("end_datetime", formatDate(lastDayOfMonth));
  }, []);

  return (
    <div className="scan-patient-qr">
      <Box
        sx={{
          width: { xs: "95%", sm: "90%", md: "90%" },
          maxWidth: "1200px",
          m: "auto",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
          alignItems: "stretch",
        }}
      >
        <Box
          ref={qrCardRef}
          sx={{
            flex: 1,
            p: { xs: 2, md: 3 },
          }}
        >
          <div className="form-group department-select" style={{ marginBottom: "16px" }}>
            <label htmlFor="registrationType" className="department-label">
              Registration Type
            </label>
            <select
              id="registrationType"
              className="department-dropdown"
              value={registrationType}
              onChange={(e) => setRegistrationType(e.target.value)}
              disabled={!isAbdmEnabled}
            >
              <option value="abdm">ABDM Registration</option>
              <option value="non-abdm">Non ABDM Registration</option>
            </select>
            {!isAbdmEnabled && (
              <p className="text-muted" style={{ fontSize: "12px", marginTop: "4px" }}>
                ABDM flow disabled for this facility. Non-ABDM registration is shown.
              </p>
            )}
          </div>

          {registrationType === "abdm" ? (
            <div className="col-sm-12 col-md-12 col-lg-12 qr-container">
              <div className="qr-card">
                <div id="display_qr" className="qr-display-section">
                  {value ? (
                    <img src={value} alt="QR code" className="qr-image"></img>
                  ) : (
                    "Valid QR Code Not Available"
                  )}

                  <div className="qr-controls">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="form-group department-select">
                        <label
                          htmlFor="searchType"
                          className="department-label"
                        >
                          Choose Department
                        </label>
                        <select
                          className="department-dropdown"
                          name="searchType"
                          value={selectedDepartment}
                          onChange={(e) =>
                            setSelectedDepartment(e.target.value)
                          }
                        >
                          {departments.map((department) => (
                            <option
                              key={department.id}
                              value={department.department_name}
                            >
                              {department.department_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="scan-button-container">
                      <button
                        type="button"
                        className="btn btn__secondary btn__rounded btn__block mt-2"
                        onClick={handleDownloadAndPrint}
                        disabled={!value}
                      >
                        <span>Print QR</span>
                      </button>
                    </div>
                  </div>
                </div>

                {showFinalData &&
                decodedData !== undefined &&
                decodedData !== null ? (
                  <div className="patient-details-section">
                    <h1 className="patient-details-title">Patient Details</h1>
                    <Table
                      bordered
                      responsive
                      size="lg"
                      className="patient-table"
                    >
                      <TableHead className="patient-table-header">
                        <tr>ABHA Address</tr>
                        <tr>ABHA Number</tr>
                        <tr>Name</tr>
                        <tr>Gender</tr>
                        <tr>Date of Birth</tr>
                        <tr>District.</tr>
                        <tr>State</tr>
                        <tr>Address</tr>
                      </TableHead>
                      <TableBody className="patient-table-body">
                        <td>
                          <tr
                            className="patient-detail-item"
                            data-label="ABHA Address:"
                          >
                            {decodedData.hid}
                          </tr>
                          <tr
                            className="patient-detail-item"
                            data-label="ABHA Number:"
                          >
                            {decodedData.hidn}
                          </tr>
                          <tr
                            className="patient-detail-item"
                            data-label="Name:"
                          >
                            {decodedData.name}
                          </tr>
                          <tr
                            className="patient-detail-item"
                            data-label="Gender:"
                          >
                            {decodedData.gender === "M" ? "Male" : "Female"}
                          </tr>
                          <tr
                            className="patient-detail-item"
                            data-label="Date of Birth:"
                          >
                            {decodedData.dob}
                          </tr>
                          <tr
                            className="patient-detail-item"
                            data-label="District:"
                          >
                            {decodedData["dist name"]}
                          </tr>
                          <tr
                            className="patient-detail-item"
                            data-label="State:"
                          >
                            {decodedData["state name"]}
                          </tr>
                          <tr
                            className="patient-detail-item"
                            data-label="Address:"
                          >
                            {decodedData.address}
                          </tr>
                        </td>
                      </TableBody>
                    </Table>
                  </div>
                ) : (
                  []
                )}

                {healthIdDetails &&
                purpose !== undefined &&
                healthIdDetails !== null ? (
                  <div className="visit-details-section">
                    <h1 className="visit-details-title">
                      Visit Purpose Details{" "}
                    </h1>
                    <Table
                      bordered
                      responsive
                      size="lg"
                      className="visit-table"
                    >
                      <TableHead className="visit-table-header">
                        <tr>Visit Purpose ID</tr>
                        <tr>Purpose</tr>
                        <tr>Creation Date and Time</tr>
                      </TableHead>
                      <TableBody className="visit-table-body">
                        <td>
                          <tr
                            className="visit-detail-item"
                            data-label="Visit Purpose ID:"
                          >
                            {healthIdDetails.reference_number}
                          </tr>
                          <tr
                            className="visit-detail-item"
                            data-label="Purpose:"
                          >
                            {purpose}
                          </tr>
                          <tr
                            className="visit-detail-item"
                            data-label="Creation Date and Time:"
                          >
                            {new Date().toLocaleString()}
                          </tr>
                        </td>
                      </TableBody>
                    </Table>
                  </div>
                ) : (
                  []
                )}
              </div>
            </div>
          ) : (
            <div
              className="col-sm-12 col-md-12 col-lg-12 qr-container"
              style={{ maxWidth: "360px", width: "100%" }}
            >
              <div className="qr-card" style={{ width: "100%" }}>
                <div id="non_abdm_qr" className="qr-display-section">
                  <div
                    ref={nonAbdmQrRef}
                    className="qr-image"
                    style={{
                      padding: "12px",
                      backgroundColor: "#ffffff",
                      borderRadius: "12px",
                      width: "100%",
                      maxWidth: "260px",
                      margin: "0 auto",
                    }}
                  >
                    <QRCode
                      value={nonAbdmQrUrl}
                      size={150}
                      bgColor="#FFFFFF"
                      fgColor="#000000"
                      level="M"
                    />
                  </div>
                  <div
                    className="qr-controls"
                    style={{
                      justifyContent: "center",
                      marginTop: "16px",
                    }}
                  >
                    <div className="scan-button-container">
                      <button
                        type="button"
                        className="btn btn__secondary btn__rounded btn__block mt-2"
                        onClick={handleDownloadNonAbdmQr}
                        disabled={!nonAbdmQrUrl}
                      >
                        <span>Download QR</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Box>

        <Divider orientation="vertical" flexItem sx={{ display: { xs: "none", md: "block" } }} />

        <Card
          sx={{
            backgroundColor: "#FDFDFD",
            borderRadius: "12px",
            flex: 1,
            p: 0,
            boxShadow: "0px 4px 4px 0px #00000040",
            minHeight: qrCardHeight ? `${qrCardHeight}px` : undefined,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#213360",
              color: "#FFFFFF",
              px: "24px",
              minHeight: "72px",
              display: "flex",
              alignItems: "center",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              borderBottom: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 500, color: "#FFFFFF", fontSize: "24px" }}>
              Get Scan & Share Records
            </Typography>
          </Box>
          <Box sx={{ px: 3, py: 3 }}>
            <form className="contact-panel__form" onSubmit={handleSubmit(getScanShareRecords)}>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <label style={{ color: "#495057" }}>Start Date</label>
                  <div className="form-group form-group-date">
                    <i className="icon-calendar form-group-icon"></i>
                    <input
                      type="date"
                      className="form-control main-form-select"
                      name="start_datetime"
                      {...register("start_datetime", {
                        required: "Start Date is required.",
                      })}
                    />
                    {errors.start_date && (
                      <p className="errorMsg">{errors.start_date.message}</p>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <label style={{ color: "#495057" }}>End Date</label>
                  <div className="form-group form-group-date">
                    <i className="icon-calendar form-group-icon"></i>
                    <input
                      type="date"
                      className="form-control main-form-select"
                      placeholder="Enter End Date"
                      name="end_datetime"
                      {...register("end_datetime", {
                        required: "End Date is required.",
                      })}
                    />
                    {errors.end_date && (
                      <p className="errorMsg">{errors.end_date.message}</p>
                    )}
                  </div>
                </div>
              </div>
              <input type="hidden" name="recordType" {...register("recordType")} />
              <div className="row justify-content-center">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <button
                    type="submit"
                    name="recordType"
                    value="scan_share"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    onClick={() => {
                      setFormValue("recordType", "scan_share");
                    }}
                  >
                    <span>Get Records</span> <i className="icon-arrow-right"></i>
                  </button>
                </div>
              </div>
              <div className="contact-result"></div>
            </form>
          </Box>
        </Card>
      </Box>

      {/* {displayExistingDetails && (
        <div
          className="contact-panel mb-5 m-auto"
          style={{
            width: "50vw",
            display: "flex",
            flexDirection: "row",
            padding: "30px",
          }}
        >
          <Icon name="scanandshareicon" size={28} />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#000",
              }}
            >
              Total Records:
            </span>
            <span
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#000",
              }}
            >
              {scanShareRecords !== undefined
                ? scanShareRecords.scan_share_token_list.length
                : "0"}
            </span>
          </div>
        </div>
      )} */}

      {displayExistingDetails ? (
        <div style={{ paddingTop: "3%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "auto",
              width: "100%",
              maxWidth: "1200px",
              padding: "1rem",
            }}
          >
            <div className="main-title" style={{ textAlign: "center" }}>
              Scan & Share Records List
            </div>
            <div style={{ width: "100%" }}>
              <DataGrid
                rows={scanShareRows}
                columns={scanShareColumns}
                components={{
                  Toolbar: () => (
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ mb: 2 }}
                    >
                      <Grid item xs={12} sm={6} md={8} sx={{ display: "flex", gap: 1 }}>
                        <GridToolbarColumnsButton />
                        <GridToolbarFilterButton />
                        <GridToolbarDensitySelector />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        sx={{ display: "flex", gap: 1, justifyContent: { xs: "center", sm: "flex-end" } }}
                      >
                        <Button variant="text" color="primary" onClick={() => generatePdf()} startIcon={<SaveAlt />}>
                          Download PDF
                        </Button>
                        <CSVLink data={generateCsvData()} filename={"scan_share_records.csv"} target="_blank">
                          <Button variant="text" color="primary" startIcon={<SaveAlt />}>
                            Download CSV
                          </Button>
                        </CSVLink>
                      </Grid>
                    </Grid>
                  ),
                }}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 },
                  },
                }}
                pageSizeOptions={[5, 10]}
                getRowClassName={getRowClassName}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "1px solid #e0e0e0",
                    borderRadius: "4px",
                    fontFamily: "Arial, sans-serif",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#125386",
                    color: "white",
                    fontSize: "13px",
                    fontWeight: "600",
                    minHeight: "48px !important",
                    "& .MuiDataGrid-columnHeaderTitle": {
                      color: "white",
                      fontWeight: "600",
                      fontSize: "13px",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                      padding: "0 12px",
                    },
                    "& .MuiDataGrid-columnHeader:last-child": {
                      borderRight: "none",
                    },
                    "& .MuiDataGrid-iconButtonContainer": {
                      color: "white",
                    },
                    "& .MuiDataGrid-menuIcon": {
                      color: "white",
                    },
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                    "& .MuiDataGrid-columnHeaderSortable": {
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                    },
                    "& .MuiDataGrid-columnHeaderTitleContainer": {
                      "& .MuiDataGrid-sortIcon": {
                        color: "white",
                      },
                    },
                    "& .MuiSvgIcon-root": {
                      color: "white",
                    },
                  },
                  "& .MuiDataGrid-row": {
                    backgroundColor: "white",
                    minHeight: "40px !important",
                    "&:nth-of-type(even)": {
                      backgroundColor: "white",
                    },
                    "&:hover": {
                      backgroundColor: "#f8f9fa",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#e3f2fd",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                      },
                    },
                    borderBottom: "1px solid #e0e0e0",
                  },
                  "& .MuiDataGrid-cell": {
                    borderRight: "1px solid #e0e0e0",
                    fontSize: "12px",
                    color: "#374151",
                    padding: "8px 12px",
                    minHeight: "40px !important",
                    "&:last-child": {
                      borderRight: "none",
                    },
                    "&:focus": {
                      outline: "none",
                    },
                  },
                  "& .MuiDataGrid-cellContent": {
                    fontSize: "12px",
                    color: "#374151",
                    fontWeight: "400",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    backgroundColor: "#f8f9fa",
                    borderTop: "1px solid #e0e0e0",
                    minHeight: "52px",
                  },
                  "& .MuiTablePagination-root": {
                    color: "#374151",
                    fontSize: "12px",
                  },
                  "& .MuiDataGrid-toolbarContainer": {
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e0e0e0",
                    padding: "8px 16px",
                  },
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        []
      )}

      

      {/* <QRCodeScanner /> */}
      {/* commented for now for cleaner UI */}
      {/* </> */}
    </div>
  );
}

export default ScanPatientQR;
